import "./Banglore_cities.css";
const Hyderabad_cities = ()=>{
    return(
        <div className="main_div">
            <h2 className="city">Popular Localities</h2>
            <p className="city">Secunderabad Railway Station</p>
            <p className="city">Gachibowli</p>
            <p className="city">Madhapur</p>
            <p className="city">LB Nagar</p>
            <p className="city">Ameerpet</p>
            <p className="city">Kukatpally</p>
            <p className="city">Hitech City</p>
            <p className="city">Begumpet</p>
            <p className="city">All of Hyderabad</p>
           
        </div>
    )
}
export {Hyderabad_cities}